// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media (max-width: 768px) {
  .inbox {
    background-color: #ffffff;
    border-radius: 4px;
    padding: 0;
    margin: 0 0 20px;
  }
  .inbox div a {
    border-bottom: 1px solid #ccc;
    display: block;
    color: #555;
    font-size: 14px;
    padding: 10px 0;
  }
  .inbox div a:hover {
    color: #204687;
  }
  .inbox div a:first-child {
    padding-top: 0;
  }
  .inbox div a:last-child {
    padding-bottom: 0;
    border-bottom: none;
  }
  .inbox div .active {
    color: #204687;
  }
}
@media (min-width: 768px) {
  .inbox-right {
    width: calc(100% - 420px);
  }
}
.coursel {
  width: 1150px;
  height: 500px;
  margin: 0 auto;
}

@media screen and (max-width: 995px), screen and (max-height: 700px) {
  .coursel {
    width: 1150px;
    height: 500px;
    margin: 0 auto;
    overflow: visible;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/home/home-page/home-page.component.scss"],"names":[],"mappings":"AAEA;EACE;IACE,yBAAA;IACA,kBAAA;IACA,UAAA;IACA,gBAAA;EADF;EAGI;IACE,6BAAA;IACA,cAAA;IACA,WAAA;IACA,eAAA;IACA,eAAA;EADN;EAGM;IACE,cAAA;EADR;EAGM;IACE,cAAA;EADR;EAGM;IACE,iBAAA;IACA,mBAAA;EADR;EAII;IACE,cAAA;EAFN;AACF;AAMA;EACE;IACE,yBAAA;EAJF;AACF;AAOA;EACE,aAAA;EACA,aAAA;EACA,cAAA;AALF;;AAOA;EAEE;IACE,aAAA;IACA,aAAA;IACA,cAAA;IACA,iBAAA;EALF;AACF","sourcesContent":["@import \"mediaquery\";\n\n@media (max-width: 768px) {\n  .inbox {\n    background-color: #ffffff;\n    border-radius: 4px;\n    padding: 0;\n    margin: 0 0 20px;\n    div {\n      a {\n        border-bottom: 1px solid #ccc;\n        display: block;\n        color: #555;\n        font-size: 14px;\n        padding: 10px 0;\n\n        &:hover {\n          color: #204687;\n        }\n        &:first-child {\n          padding-top: 0;\n        }\n        &:last-child {\n          padding-bottom: 0;\n          border-bottom: none;\n        }\n      }\n      .active {\n        color: #204687;\n      }\n    }\n  }\n}\n@media (min-width: 768px) {\n  .inbox-right {\n    width: calc(100% - 420px);\n  }\n}\n\n.coursel {\n  width: 1150px;\n  height: 500px;\n  margin: 0 auto\n}\n@media screen and (max-width: 995px),\nscreen and (max-height: 700px)  {\n  .coursel {\n    width: 1150px;\n    height: 500px;\n    margin: 0 auto;\n    overflow: visible;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
